<template>
  <section class="section">
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 15px 0;">
      <el-breadcrumb-item>智慧校园信息服务云平台</el-breadcrumb-item>
    </el-breadcrumb>
    <hr />
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card>
          <div slot="header">数据统计</div>
          <div class="statics">
            <dl>
              <dt>学校</dt>
              <dd>
                <div class="yhImg">
                  <img src="/static/index/zhuceImg_03.png" />
                </div>
                <span>{{dataStatistics.SchoolCount}}</span>
              </dd>
            </dl>
            <dl>
              <dt>教师</dt>
              <dd>
                <div class="yhImg">
                  <img src="/static/index/zhuceImg_05.png" />
                </div>
                <span>{{dataStatistics.TeacherCount}}</span>
              </dd>
            </dl>
            <dl>
              <dt>学生</dt>
              <dd>
                <div class="yhImg">
                  <img src="/static/index/zhuceImg_11.png" />
                </div>
                <span>{{dataStatistics.StudentCount}}</span>
              </dd>
            </dl>
            <dl>
              <dt>家长</dt>
              <dd>
                <div class="yhImg">
                  <img src="/static/index/zhuceImg_08.png" />
                </div>
                <span>{{dataStatistics.ParentCount}}</span>
              </dd>
            </dl>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">实时统计</div>
          <div class="statics">
            <dl>
              <dt>开通应用（项）</dt>
              <dd>
                <div class="yyImg">
                  <img src="/static/index/shishiImg_03.png" />
                </div>
                <span>{{realtimeStatistics.ClientCount}}</span>
              </dd>
            </dl>
            <dl>
              <dt>访问次数（次）</dt>
              <dd>
                <div class="yyImg">
                  <img src="/static/index/shishiImg_06.png" />
                </div>
                <span>{{realtimeStatistics.VisitedCount}}</span>
              </dd>
            </dl>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-top:20px;">
      <div slot="header">应用访问统计</div>
      <div id="main"></div>
    </el-card>
  </section>
</template>
<script>
import axios from "axios";
import { server_base, base } from "../../../common/config";
import {
  GetDataStatistics,
  GetRealtimeStatistics,
  GetClientVisitedStatistics
} from "../../../api/rpt/rpt";
import echarts from "echarts";
import qs from "qs";
export default {
  data() {
    return {
      dataStatistics: {
        SchoolCount: 0,
        TeacherCount: 0,
        ParentCount: 0,
        StudentCount: 0
      },
      realtimeStatistics: {
        ClientCount: 0,
        VisitedCount: 0
      },
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          // 控制图的大小，调整下面这些值就可以，
          x: 50, //控制x轴文字与底部的距离
          x2: 0,
          y2: 50 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
        },
        title: {
          text: "应用访问统计",
          subtext: "每个应用总访问次数，按应用名称排列"
        },
        legend: {
          data: []
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: 0, //强制文字产生间隔
            rotate: 45, //文字逆时针旋转45°
            textStyle: {
              //文字样式
              color: "#333",
              fontSize: 11
              // fontFamily: 'Microsoft YaHei'
            }
          },

          data: []
          // axisLabel: {
          //   inside: false,
          //   textStyle: {
          //     //color: "#fff"
          //   }
          // },
          // axisTick: {
          //   show: true
          // },
          // axisLine: {
          //   show: true
          // }
        },
        yAxis: {
          // axisLine: {
          //   show: true
          // },
          // axisTick: {
          //   show: true
          // },
          // axisLabel: {
          //   textStyle: {
          //     color: "#999"
          //   }
          // }
        },
        series: [
          // {
          //   // For shadow
          //   type: "bar",
          //   itemStyle: {
          //     normal: { color: "rgba(0,0,0,0.05)" }
          //   },
          //   barGap: "-100%",
          //   barCategoryGap: "40%",
          //   data: [],
          //   animation: false
          // },
          {
            type: "bar",
            name: "访问次数",
            label: {
              normal: {
                show: true,
                position: "top"
              }
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" }
                ])
              }
            },
            data: []
          }
        ]
      }
    };
  },
  methods: {
    // getDataStatistics: function() {
    //   this.$axios.get('/api/local/SC/RPT/GetDataStatistics').then(result => {
    //     if (result.success) {
    //       this.dataStatistics = result.data || {};
    //     }
    //   });
    // },
    // getRealtimeStatistics: function() {
    //   this.$axios.get('/api/local/SC/RPT/GetRealtimeStatistics').then(result => {
    //     if (result.success) {
    //       this.realtimeStatistics = result.data || {};
    //     }
    //   });
    // },
    // getClientVisitedStatistics: function() {
    //   this.$axios.get('/api/local/SC/RPT/GetClientVisitedStatistics').then(result => {
    //     if (result.success) {
    //       var dataAxis = [];
    //       var data = [];
    //       var dataShadow = [];
    //       var maxY = 0;
    //       for (var i = 0; i < result.data.length; i++) {
    //         dataAxis.push(result.data[i].ClientName);
    //         data.push(result.data[i].VisitedCount);
    //         if (maxY < result.data[i].VisitedCount) {
    //           maxY = result.data[i].VisitedCount;
    //         }
    //         dataShadow.push(maxY);
    //       }
    //       for (var i = 0; i < dataShadow.length; i++) {
    //         dataShadow[i] = parseInt(maxY * 1.5);
    //       }
    //       //this.option.legend.data = dataAxis;
    //       this.option.xAxis.data = dataAxis;
    //       //this.option.series[0].data = dataShadow;
    //       this.option.series[0].data = data;
    //       var main = echarts.init(document.getElementById("main"));
    //       main.setOption(Object.assign({}, this.option));
    //     }
    //   });
    // }
  },
  mounted: function() {
    let that = this;
    // this.getDataStatistics();
    // this.getRealtimeStatistics();
    // this.getClientVisitedStatistics();


  
  }
};
</script>
<style scoped lang="scss">
#main {
  width: 100%;
  min-height: 300px;
  
}
.section {
  background: #fff;
  padding: 10px 30px 35px 30px;
  height: 100%;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.content {
  font-size: 14px;
}

.el-row {
  margin-top: 20px;
}
.statics {
  display: flex;
  display: -webkit-flex;
  dl {
    flex: 1;
    text-align: center;
    dt {
      font-size: 14px;
    }
    dd {
      div {
        padding: 15px;
        img {
          background-color: transparent;
          width: 40px;
          height: 44px;
          max-width: 40px;
          max-height: 44px;
        }
      }
      span {
        color: #42b886;
        font-size: 26px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/public/WelCome.vue